import { render, staticRenderFns } from "./pre-made-msg-modal.vue?vue&type=template&id=339c25ec&scoped=true&"
import script from "./pre-made-msg-modal.vue?vue&type=script&lang=js&"
export * from "./pre-made-msg-modal.vue?vue&type=script&lang=js&"
import style0 from "./pre-made-msg-modal.vue?vue&type=style&index=0&id=339c25ec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "339c25ec",
  null
  
)

export default component.exports